import { type AnimationEvent, useState } from 'react';

/**
 * Rattles an element once each time `attention` is bumped. Which bump it has
 * already rattled for is remembered, so the class stays on until the run ends;
 * keying the element instead would remount it and drop the caret it holds.
 */
export function useRattle(attention: number | undefined) {
  const [rattledFor, setRattledFor] = useState<number | undefined>(undefined);
  const rattling = Boolean(attention) && attention !== rattledFor;

  function onAnimationEnd(event: AnimationEvent) {
    if (event.target === event.currentTarget) setRattledFor(attention);
  }

  return { rattling, onAnimationEnd };
}
